const parseResponse = async (response) => {
    const data = await response.json().catch(() => null);

    if (!response.ok) {
        return data ?? {
            status: 'error',
            error: response.statusText
        };
    }

    return data;
};

const userService = {
    async get() {
        const apiURL = process.env.REACT_APP_API + '/user';
        const token = localStorage.getItem('token') ?? null;

        let headers = {
            'Accept': 'application/json',
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
        return await fetch(apiURL, {
            method: "POST",
            headers: headers
        })
        .then(parseResponse)
        .then((data) => {
            return data;
        })
        .catch((error) => {
            return error;
        });
    },
    async update(data) {
        const apiURL = process.env.REACT_APP_API + '/userupdate';
        const token = localStorage.getItem('token') ?? null;

        let headers = {
            'Accept': 'application/json',
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
        return await fetch(apiURL, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(data)
        })
        .then(parseResponse)
        .then((data) => {
            return data;
        })
        .catch((error) => {
            return error;
        });
    },
    async password(data) {
        const apiURL = process.env.REACT_APP_API + '/changepassword';
        const token = localStorage.getItem('token') ?? null;

        let headers = {
            'Accept': 'application/json',
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
        return await fetch(apiURL, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(data)
        })
        .then(parseResponse)
        .then((data) => {
            return data;
        })
        .catch((error) => {
            return error;
        });
    },
    async emailValidation(data) {
        const apiURL = process.env.REACT_APP_API + '/emailValidation';
        const token = localStorage.getItem('token') ?? null;

        let headers = {
            'Accept': 'application/json',
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
        return await fetch(apiURL, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(data)
        })
        .then(parseResponse)
        .then((data) => {
            return data;
        })
        .catch((error) => {
            return error;
        });
    },
    async sendEmailValidation() {
        const apiURL = process.env.REACT_APP_API + '/sendEmailValidation';
        const token = localStorage.getItem('token') ?? null;

        let headers = {
            'Accept': 'application/json',
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
        return await fetch(apiURL, {
            method: "POST",
            headers: headers
        })
        .then(parseResponse)
        .then((data) => {
            return data;
        })
        .catch((error) => {
            return error;
        });
    },
    async redefinePass(data) {
        const apiURL = process.env.REACT_APP_API + '/redefinePass';
        const token = localStorage.getItem('token') ?? null;

        let headers = {
            'Accept': 'application/json',
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
        return await fetch(apiURL, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(data)
        })
        .then(parseResponse)
        .then((data) => {
            return data;
        })
        .catch((error) => {
            return error;
        });
    },
    async sendEmailRedefinePass(data) {
        const apiURL = process.env.REACT_APP_API + '/sendEmailRedefinePass';
        const token = localStorage.getItem('token') ?? null;

        let headers = {
            'Accept': 'application/json',
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
        return await fetch(apiURL, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(data)
        })
        .then(parseResponse)
        .then((data) => {
            return data;
        })
        .catch((error) => {
            return error;
        });
    },
    async rating(data) {
        const apiURL = process.env.REACT_APP_API + '/rating';
        const token = localStorage.getItem('token') ?? null;

        let headers = {
            'Accept': 'application/json',
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
        return await fetch(apiURL, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(data)
        })
        .then(parseResponse)
        .then((data) => {
            return data;
        })
        .catch((error) => {
            return error;
        });
    },
    async checkRating() {
        const apiURL = process.env.REACT_APP_API + '/checkrating';
        const token = localStorage.getItem('token') ?? null;

        let headers = {
            'Accept': 'application/json',
            'Content-type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
        return await fetch(apiURL, {
            method: "POST",
            headers: headers
        })
        .then(parseResponse)
        .then((data) => {
            return data;
        })
        .catch((error) => {
            return error;
        });
    }
}

export default userService;
